import React, { useState } from 'react';
import {useQuoteState} from "./quoteState";
import {Modal} from "../../modal/Modal";

// Filter out options with empty values & map a new array with the label as the key and the value as the value
function formatOptions(options) {
    return Object.entries(options)
        .filter(([key, value]) => value)
        .map(([key, value]) => ({ 
            key, 
            label: key, 
            value: value.replace(/\s*\+.*$/, '') 
        }));
}

// Fetch cart from Shopify ASYNC
async function fetchCart() {
    const response = await fetch("".concat(window.routes.cartUrl, ".js"), {
        method: 'GET', headers: {'Content-Type': 'application/json'}
    })
    const cart = await response.json();
    // console.log('cart.items', cart.items);

    return cart.items.map(cart_item => {
        return {
            id: cart_item.variant_id,
            properties: formatOptions(cart_item.properties),
            quantity: cart_item.quantity,
            productId: cart_item.product_id,
            variantId: cart_item.variant_id,
            price: cart_item.price,
            url: "/products/" + cart_item.handle + "?variant=" + cart_item.variant_id,
            options: formatOptions(cart_item.properties),
            title: cart_item.product_title,
            variantTitle: cart_item.variant_title,
            featuredImage: cart_item.image,
            aspectRatio: cart_item.featured_image.aspect_ratio,
            compareAtPrice: cart_item.price == cart_item.original_price ? null : cart_item.original_price,
            // leadTime: leadTimeEl,
            brand: cart_item.vendor,
            sku: cart_item.sku,
            // shopifyId: "shopify_US_" + product.id + "_" + variant.id
        }
    })
    // return final_items;
}

export const ConvertToQuote = () => {
    // const isBtn = false;
    const { setConvertCartItems, setShowMiniQuote } = useQuoteState();
    const [showModal, setShowModal] = useState(false);

    const openConfirmation = (e) => {
        e.preventDefault();
        setShowModal(true);
    }
    async function handleConvertToQuote() {
        setShowModal(false);
        const cart_items = await fetchCart();
        // console.log('cart-items', cart_items);
        const cart_json = JSON.stringify(cart_items);
        localStorage.setItem("quoteItems", cart_json);
        setConvertCartItems(cart_items);
        setShowMiniQuote(true);

        // console.log('setConvertCartItems', ecommerce_items(cart_items));

        if(window.ElevarDataLayer) {
            window.ElevarDataLayer.push({"event": "convert_to_quote"})
        }
    }

    

    

    
    return (
        <>
            <button id="ConvertToQuoteBtn" className="button button--ternary button--full button--large" style={{width: "100%"}} onClick={openConfirmation} >Convert to Quote</button>

            <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
                <p>Converting a cart to quote will delete and replace all items currently in the quote.</p>
                <div className="quote-modal-buttons">
                    <button id="ConvertToQuoteBtn" className="button button--primary" onClick={handleConvertToQuote} >Convert to Quote</button>
                    <button className="button button--primary" onClick={() => setShowModal(false)}>Cancel</button>
                </div>
            </Modal>
        </>
    );
}


